module.exports = __webpack_public_path__ + "9022e286e1d955285ed2d0be8a3265a5.png";